module.exports = __webpack_public_path__ + "static/media/9.8c2a27f0.jpg";